import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const suppliersRoutesDictionary = moduleRouteDictionaryFactory(
  'suppliers',
  'suppliers',
  {
    list: 'list',
    create: 'create',
    update: 'update/:supplierId',
    detail: 'detail/:supplierId',
    createLocation: 'detail/:supplierId/locations/create',
    editLocation: 'detail/:supplierId/locations/:locationId/edit/',
    createService: 'detail/:supplierId/services/create',
    serviceOverview: 'detail/:supplierId/services/:id',
    editService: 'detail/:supplierId/services/:id/edit/',
    editContractPayments: 'detail/:supplierId/contract-payments/edit',
    createSupplierUser: 'detail/:supplierId/users/create',
    voucherCodes: 'detail/:supplierId/voucher-codes/:fileId',
  },
);
